      $('.mv_top').slick({
            autoplay: true,
            speed: 1200,
            autoplaySpeed: 2800,
            //dots: true,
            //dotsClass: "slide-dots",
            arrows: true,
            prevArrow: '<button type="button" class="slick-prev btn_arr"><span>前へ</span></button>',
            nextArrow: '<button type="button" class="slick-next btn_arr"><span>次へ</span></button>',
            slidesToShow: 1,
      });

  $('.mv_thumb').slick({
      asNavFor:'.mv_top',
      focusOnSelect: true,
      slidesToShow:4,
      slidesToScroll:1,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 2800,
      speed: 400,
  });  